module.exports = __webpack_public_path__ + "static/media/reefocus background 1.3.9fd18904.jpg";